<ng-container *ngIf="useNewLayout; else oldLayoutTemplate">
    <table [width]="this.width" class="new-use-case-layout">
        <tr>
            <td width="70%">
                <table *ngIf="!this.sAccount.isdeliverylead" width="100%" class="edit-indicator" (click)="openStatusEdit('Top Section')">
                    <tr>
                        <td class="a-label-new" style="width: 120px;" rowspan="2">Account</td>
                        <td class="a-value" style="width: 30%;" rowspan="2">{{this.sAccount["name"]}}</td>
                        <td matTooltip="Account Executive" class="a-label2" style="width: 40px;">AE</td>
                        <td class="a-value2" style="width: 20%; height: 20px;">{{getASValue("agm")}}</td>
                        <td class="a-label2" style="width: 120px;">Account SFID</td>
                        <td class="a-value2">{{this.sAccount["sfid"]=="null"?"":this.sAccount["sfid"]}}</td>
                    </tr>
                    <tr>
                        <td matTooltip="Account Delivery Lead" class="a-label2">ADL</td>
                        <td class="a-value2" style="height: 20px;">{{getASValue("adl")}}</td>
                        <td class="a-label2" rowspan="2">Prepared By</td>
                        <td class="a-value2" rowspan="2">{{getASValue("preparedby")}}</td>
                    </tr>
                    <tr>
                        <td class="a-label-new">Revision Date</td>
                        <td class="a-value">{{getASValue("capturedate")}}</td>
                        <td matTooltip="Technology Sales Consultant" class="a-label2">TSC</td>
                        <td class="a-value2" style="height: 20px;">{{getASValue("ct")}}</td>
                    </tr>
                </table>
                <table *ngIf="this.sAccount.isdeliverylead" width="100%" class="edit-indicator" (click)="openStatusEdit('Top Section')">
                    <tr>
                        <td class="a-label-new" style="width: 120px;" rowspan="2">Account</td>
                        <td class="a-value" style="width: 30%;" rowspan="2">{{this.sAccount["name"]}}</td>
                        <td matTooltip="Account Executive" class="a-label2 a-label4" style="width: 40px;">AE</td>
                        <td class="a-value2 a-label4" style="width: 20%; height: 20px;">{{getASValue("agm")}}</td>
                        <td class="a-label2" style="width: 120px;" rowspan="2">Account SFID</td>
                        <td class="a-value2" rowspan="2">{{this.sAccount["sfid"]=="null"?"":this.sAccount["sfid"]}}</td>
                    </tr>
                    <tr>
                        <td matTooltip="Account Delivery Lead" class="a-label2 a-label4">ADL</td>
                        <td class="a-value2 a-label4" style="height: 20px;">{{getASValue("adl")}}</td>
                    </tr>
                    <tr>
                        <td class="a-label-new" rowspan="2">Revision Date</td>
                        <td class="a-value" rowspan="2">{{getASValue("capturedate")}}</td>
                        <td matTooltip="Technology Sales Consultant" class="a-label2 a-label4">TSC</td>
                        <td class="a-value2 a-label4" style="height: 20px;">{{getASValue("ct")}}</td>
                        <td class="a-label2" rowspan="2">Prepared By</td>
                        <td class="a-value2" rowspan="2">{{getASValue("preparedby")}}</td>
                    </tr>
                    <tr *ngIf="this.sAccount.isdeliverylead">
                        <td matTooltip="Portfolio Lead / Sub Region Lead" class="a-label2 a-label4">PL/SRL</td>
                        <td class="a-value2 a-label4" style="height: 20px;">{{getASValue("pl")}}</td>
                    </tr>
                </table>
            </td>
            <td width="15%">
                <table width="100%" class="edit-indicator" (click)="openStatusEdit('Revenue & Staff')">
                    <tr>
                        <td colspan="2" class="a-label3 backround-primary">Account Finances</td>
                    </tr>
                    <tr>
                        <td width="50%" class="a-label3 backround-primary">REV</td>
                        <td width="50%" class="a-label3 backround-primary">TCV</td>
                    <tr>
                        <td class="a-label3 a-grey-background1">{{getASValue("rev")}}</td>
                        <td class="a-label3 a-grey-background1">{{getASValue("tcv")}}</td>
                    </tr>
                </table>
            </td>
            <td width="15%">
                <table width="100%" class="edit-indicator" (click)="openStatusEdit('Revenue & Staff')">
                    <tr>
                        <td colspan="2" class="a-label3 backround-primary">DXC Staff on Account</td>
                    </tr>
                    <tr>
                        <td width="50%" class="a-label3 backround-primary">Headcount</td>
                        <td width="50%" class="a-label3 backround-primary">On/Off Mix</td>
                    </tr>
                    <tr>
                        <td class="a-label3 a-grey-background1">{{getASValue("hc")}}</td>
                        <td class="a-label3 a-grey-background1">{{getASValue("onoffmix")}}</td>
                    </tr>
                </table>
            </td>
        </tr>
    
        <tr>
            <td>
                <table width="100%" class="edit-indicator" (click)="openStatusEdit('Observations/Risks')">
                    <tr>
                        <td class="a-label-new" style="height:110px;width: 120px;">Key Observations</td>
                        <td class="a-value3" style="height:110px;padding:0;">
                            <div [innerHTML]="getASValue('observations')" style="padding: 10px;"></div>
                        </td>
                    </tr>
                    <tr>
                        <td class="a-label-new" style="height:110px;width: 120px;">Significant Risks</td>
                        <td class="a-value3" style="height:110px;padding:0;">
                            <div [innerHTML]="getASValue('risks')" style="padding: 10px;"></div>
                        </td>
                    </tr>
                </table>
            </td>
            <td colspan="2" style="vertical-align: top;">
                <table width="100%" height="266px" class="edit-indicator">
                    <tr height="40px" (click)="openStatusEdit('Revenue & Staff')">
                        <td class="a-label3 backround-primary">Platform X</td>
                    </tr>
                    <tr (click)="openStatusEdit('Revenue & Staff')">
                        <td class="a-value4" style="height:67px;padding:0;">
                            <div style="height:67px;padding:10px;overflow-y: auto;" [innerHTML]="getASValue('platformx')"></div>
                        </td>
                    </tr>
                    <tr height="40px" (click)="openStatusEdit('Events')">
                        <td class="a-label3 backround-primary">Events</td>
                    </tr>
                    <tr (click)="openStatusEdit('Events')">
                        <td class="a-value4" style="padding:0px;height:87px;">
                            <div style="height:87px;overflow-y: auto;">
                                <table class="edit-indicator eventTb eventBorderNew">
                                    <tr *ngFor="let num of this.eventNums" class="edit-indicator">
                                        <td>
                                            <div class="pMargin" [innerHTML]="getASValue('ev_title_'+num)"></div>
                                        </td>
                                        <td style="width:23%">
                                            <div class="pMargin" [innerHTML]="formatDate(getASValue('ev_date_'+num))"></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    
        <tr>
            <td colspan="3">
    
                <table width="100%">
                    <tr>
                        <td class="a-label-new">#</td>
                        <td class="a-label-new">Where are the Clients vulnerabilities</td>
                        <td class="a-label-new">What should we pitch to the Client to make them more resilient</td>
                        <td class="a-grey-background2">Next Steps & Action</td>
                        <td class="a-grey-background2">Owner</td>
                    </tr>
                    <tr *ngFor="let num of getStatusRows()" class="edit-indicator" (click)="openStatusEdit('List ' + num)">
                        <td class="a-value4">{{num}}</td>
                        <td class="a-value4">
                            <div [innerHTML]="getASValue('cv_'+num)"></div>
                        </td>
                        <td class="a-value4">
                            <div [innerHTML]="getASValue('pitch_'+num)"></div>
                        </td>
                        <td class="a-value4">
                            <div [innerHTML]="getASValue('nextsteps_'+num)"></div>
                        </td>
                        <td class="a-value4">
                            <div [innerHTML]="getASValue('owner_'+num)"></div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</ng-container>

<ng-template #oldLayoutTemplate>
    <table [width]="this.width">
        <tr>
            <td width="20%">
                <table width="100%" class="edit-indicator" (click)="openStatusEdit('Top Section')">
                    <tr>
                        <td class="a-label" style="height:36px;width: 120px;">Account</td>
                        <td class="a-value a-border">{{this.sAccount["name"]}}</td>
                    </tr>
                    <tr>
                        <td class="a-label" style="height:36px;">Capture Date</td>
                        <td class="a-value a-border">{{getASValue("capturedate")}}</td>
                    </tr>
                </table>
            </td>
    
            <td width="25%">
                <table width="100%" height="122px" class="a-border edit-indicator" (click)="openStatusEdit('Top Section')">
                    <tr>
                        <td matTooltip="Account Executive" class="a-label2 aip-primary-color a-label4">Account Exec:</td>
                        <td class="a-value2 aip-primary-color a-label4">{{getASValue("agm")}}</td>
                    </tr>
                    <tr>
                        <td matTooltip="Account Delivery Lead" class="a-label2 aip-primary-color a-label4">ADL:</td>
                        <td class="a-value2 aip-primary-color a-label4">{{getASValue("adl")}}</td>
                    </tr>
                    <tr>
                        <td matTooltip="Technology Sales Consultant" class="a-label2 aip-primary-color a-label4">TSC:</td>
                        <td class="a-value2 aip-primary-color a-label4">{{getASValue("ct")}}</td>
                    </tr>
                    <tr *ngIf="this.sAccount.isdeliverylead">
                        <td matTooltip="Portfolio Lead / Sub Region Lead" class="a-label2 aip-primary-color a-label4">PL/SRL:</td>
                        <td class="a-value2 aip-primary-color a-label4">{{getASValue("pl")}}</td>
                    </tr>
                </table>
            </td>
    
            <td width="25%">
                <table width="100%" height="122px" class="a-border edit-indicator" (click)="openStatusEdit('Top Section')">
                    <tr>
                        <td class="a-label2 aip-primary-color">Account SF ID:</td>
                        <td class="a-value2 aip-primary-color">{{this.sAccount["sfid"]=="null"?"":this.sAccount["sfid"]}}
                        </td>
                    </tr>
                    <tr>
                        <td class="a-label2 aip-primary-color">Prepared by:</td>
                        <td class="a-value2 aip-primary-color">{{getASValue("preparedby")}}</td>
                    </tr>
                </table>
            </td>
    
            <td width="30%">
                <table width="100%" class="edit-indicator" (click)="openStatusEdit('Revenue & Staff')">
                    <tr>
                        <td colspan="2" class="a-label3 backround-primary">Account Finances</td>
                        <td colspan="2" class="a-label3 backround-primary">DXC Staff on Account</td>
                    </tr>
                    <tr>
                        <td width="25%" class="a-label3 backround-primary">REV</td>
                        <td width="25%" class="a-label3 backround-primary">TCV</td>
                        <td width="25%" class="a-label3 backround-primary">Headcount</td>
                        <td width="25%" class="a-label3 backround-primary">On/Off Mix</td>
                    </tr>
                    <tr>
                        <td class="a-label3 a-grey">{{getASValue("rev")}}</td>
                        <td class="a-label3 a-grey">{{getASValue("tcv")}}</td>
                        <td class="a-label3 a-grey">{{getASValue("hc")}}</td>
                        <td class="a-label3 a-grey">{{getASValue("onoffmix")}}</td>
                    </tr>
                </table>
            </td>
    
    
        </tr>
    
        <tr>
            <td colspan=3>
                <table width="100%" class="edit-indicator" (click)="openStatusEdit('Observations/Risks')">
                    <tr>
                        <td class="a-label" style="height:220px;width: 120px;" rowspan="2">Key Observations + Significant
                            Risks</td>
                        <td class="a-value3 a-border" style="height:110px;">
                            <div [innerHTML]="getASValue('observations')"></div>
                        </td>
                    </tr>
                    <tr>
                        <td class="a-value3 a-border" style="height:110px;">
                            <div [innerHTML]="getASValue('risks')"></div>
                        </td>
                    </tr>
                </table>
            </td>
            <td style="vertical-align: top;">
                <table width="100%" height="272px" class="edit-indicator">
                    <tr height="40px" (click)="openStatusEdit('Revenue & Staff')">
                        <td class="a-label3 backround-primary">Platform X</td>
                    </tr>
                    <tr (click)="openStatusEdit('Revenue & Staff')">
                        <td class="a-value4 a-border" style="height:67px;padding:10px;overflow-y: auto;">
                            <div style="height:67px;" [innerHTML]="getASValue('platformx')"></div>
                        </td>
                    </tr>
                    <tr height="40px" (click)="openStatusEdit('Events')">
                        <td class="a-label3 backround-primary">Events</td>
                    </tr>
                    <tr (click)="openStatusEdit('Events')">
                        <td class="a-value4 a-border" style="padding:0px;height:87px;">
                            <div style="height:87px;overflow-y: auto;">
                                <table class="edit-indicator eventTb eventBorder">
                                    <tr *ngFor="let num of this.eventNums" class="edit-indicator">
                                        <td>
                                            <div class="pMargin" [innerHTML]="getASValue('ev_title_'+num)"></div>
                                        </td>
                                        <td style="width:23%">
                                            <div class="pMargin" [innerHTML]="formatDate(getASValue('ev_date_'+num))"></div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    
        <tr>
            <td colspan=4>
    
                <table width="100%">
                    <tr>
                        <td class="a-label">#</td>
                        <td class="a-label">Where are the Clients vulnerabilities</td>
                        <td class="a-label">What should we pitch to the Client to make them more resilient</td>
                        <td class="a-label">Next Steps & Action</td>
                        <td class="a-label">Owner</td>
                    </tr>
                    <tr *ngFor="let num of getStatusRows()" class="edit-indicator" (click)="openStatusEdit('List ' + num)">
                        <td class="a-value4 a-border">{{num}}</td>
                        <td class="a-value4 a-border">
                            <div [innerHTML]="getASValue('cv_'+num)"></div>
                        </td>
                        <td class="a-value4 a-border">
                            <div [innerHTML]="getASValue('pitch_'+num)"></div>
                        </td>
                        <td class="a-value4 a-border">
                            <div [innerHTML]="getASValue('nextsteps_'+num)"></div>
                        </td>
                        <td class="a-value4 a-border">
                            <div [innerHTML]="getASValue('owner_'+num)"></div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</ng-template>
